export default __webpack_public_path__ + "static/media/Telkari of the Sundered Skies.cf6781ab.jpg";